import React from "react";
import "./Aboutpolicy.css";

const Aboutquality = () => {
  return (
    <>
      <div className="about-quality-policy">
        <h3>Quality Is Our Priority</h3>
        <div>
          <p>
            DASMESH Mechanical Works Pvt. Ltd. was established in{" "}
            <strong>1970</strong> to provide
            <strong>
              high-quality agricultural machinery, including combine harvesters,
              rotavators, and other farming equipment
            </strong>
            to the <strong>agriculture and farming</strong> industry. We are
            based in <strong>Malerkotla, Punjab, INDIA.</strong>, and employ{" "}
            <strong>over 500</strong> people.
          </p>

          <p>
            Quality is important to our business because we value our customers.
            We strive to provide our customers with products and services which
            meet and even exceed their expectations.
          </p>

          <p>
            We are committed to continuous improvement and have established a
            Quality Management System which provides a framework for measuring
            and improving our performance.
          </p>

          <p>
            We have the following systems and procedures in place to support us
            in our aim of total customer satisfaction and continuous improvement
            throughout our business:
          </p>

          <ul>
            <li>Regular gathering and monitoring of customer feedback</li>
            <li>A customer complaints procedure</li>
            <li>
              Selection and performance monitoring of suppliers against set
              criteria
            </li>
            <li>Training and development for our employees</li>
            <li>Regular audit of our internal processes</li>
            <li>
              Measurable quality objectives which reflect our business aims
            </li>
            <li>
              Management reviews of audit results, customer feedback, and
              complaints
            </li>
          </ul>

          <p>
            Our internal procedures are reviewed regularly and are held in a
            Quality Manual which is made available to all employees.
          </p>

          <p>
            This policy is posted on the Company Notice Board and can also be
            found in the staff handbook.
          </p>

          <p>
            Although the Managing Director has ultimate responsibility for
            Quality, all employees have a responsibility within their own areas
            of work to help ensure that Quality is embedded within the whole of
            the company.
          </p>
        </div>
        <ul>
          Following tests are the regular feature in our production unit
          <li>Hardness Test</li>
          <li>Gear Box Performance Test</li>
          <li>Raw material Grades Check</li>
          <li>Durability Test</li>
          <li>Corrosion & abrasion resistance Test</li>
        </ul>
      </div>
    </>
  );
};

export default Aboutquality;
